import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_xtn_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface
  namespace: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy: boolean;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_gst_balance: fromDatatype.NumericDatatypeInterface;
  amount_wht_balance: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  amount_matched: fromDatatype.NumericDatatypeInterface;
  qty_matched: fromDatatype.NumericDatatypeInterface;
  matching_status: fromDatatype.VarcharDatatypeInterface;
  entity_branch_guid: fromDatatype.GuidDataFieldInterface
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  doc_desc: fromDatatype.VarcharDatatypeInterface;
  doc_remarks: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface
  log_json: fromDatatype.JsonDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  guid_location_2: fromDatatype.GuidDataFieldInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_xtn_generic_doc_hdr_RowClass
  implements bl_fi_xtn_generic_doc_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface
    namespace: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_location: fromDatatype.GuidDataFieldInterface;
    code_company: fromDatatype.VarcharDatatypeInterface;
    code_branch: fromDatatype.VarcharDatatypeInterface;
    code_location: fromDatatype.VarcharDatatypeInterface;
    foreign_ccy: boolean;
    base_doc_guid: fromDatatype.GuidDataFieldInterface;
    base_doc_ccy: fromDatatype.VarcharDatatypeInterface;
    base_doc_xrate: fromDatatype.NumericDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    amount_json: fromDatatype.JsonDatatypeInterface;
    amount_gst_balance: fromDatatype.NumericDatatypeInterface;
    amount_wht_balance: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    amount_matched: fromDatatype.NumericDatatypeInterface;
    qty_matched: fromDatatype.NumericDatatypeInterface;
    matching_status: fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid: fromDatatype.GuidDataFieldInterface
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    doc_desc: fromDatatype.VarcharDatatypeInterface;
    doc_remarks: fromDatatype.VarcharDatatypeInterface;
    doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
    doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    label_json: fromDatatype.JsonDatatypeInterface;
    status_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    billing_json: fromDatatype.JsonDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface
    log_json: fromDatatype.JsonDatatypeInterface;
    due_date: fromDatatype.TimestampTzDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    client_entity_code: fromDatatype.VarcharDatatypeInterface;
    client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
    client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
    client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
    client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
    client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    guid_location_2: fromDatatype.GuidDataFieldInterface;
    wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
    wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
    wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
    contact_key_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
